<div class="service-history-container">
  <!-- Header Section -->
  <div class="service-history-header">
    <div class="header-content">
      <h3 class="service-title">Service History</h3>

      <!-- Search Input -->
      <div class="search-input-wrapper">
        <div class="search-input-container">
          <div class="search-icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 11.25L7.75 7.75M0.75 4.83333C0.75 5.36956 0.855619 5.90054 1.06083 6.39596C1.26603 6.89137 1.56681 7.34151 1.94598 7.72069C2.32515 8.09986 2.7753 8.40063 3.27071 8.60584C3.76612 8.81105 4.2971 8.91667 4.83333 8.91667C5.36956 8.91667 5.90054 8.81105 6.39596 8.60584C6.89137 8.40063 7.34151 8.09986 7.72069 7.72069C8.09986 7.34151 8.40063 6.89137 8.60584 6.39596C8.81105 5.90054 8.91667 5.36956 8.91667 4.83333C8.91667 4.2971 8.81105 3.76612 8.60584 3.27071C8.40063 2.7753 8.09986 2.32515 7.72069 1.94598C7.34151 1.56681 6.89137 1.26603 6.39596 1.06083C5.90054 0.855618 5.36956 0.75 4.83333 0.75C4.2971 0.75 3.76612 0.855618 3.27071 1.06083C2.7753 1.26603 2.32515 1.56681 1.94598 1.94598C1.56681 2.32515 1.26603 2.7753 1.06083 3.27071C0.855619 3.76612 0.75 4.2971 0.75 4.83333Z"
                stroke="#A7ABB3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            class="search-input"
            placeholder="Search service history..."
            [(ngModel)]="searchQuery"
            (input)="onSearchChange()"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading service history...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <p class="error-message">{{ error }}</p>
    <button class="retry-btn" (click)="loadServiceHistory()">Try Again</button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && filteredRecords.length === 0" class="empty-state-container">
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img src="assets/images/empty-state-illustration.svg" alt="No history illustration" />
      </div>
      <div class="empty-state-text">
        <h3 class="empty-state-title">No Service History</h3>
        <p class="empty-state-description">
          There are no service records to display for this vehicle.
        </p>
      </div>
    </div>
  </div>

  <!-- Service Records List -->
  <div *ngIf="!loading && !error && filteredRecords.length > 0" class="service-records-list">
    <div *ngFor="let record of filteredRecords; trackBy: trackByIndex" class="service-record-card">
      <!-- Card Content -->
      <div class="card-content">
        <!-- Header Row -->
        <div class="card-header-row">
          <div class="package-info">
            <h4 class="package-name">{{ record.packageName }}</h4>
            <span *ngIf="record.isPlanChangeRecord" class="plan-change-chip">{{
              record.sourceLabel
            }}</span>
            <span
              *ngIf="record.isPlanChangeRecord && record.planChangeStatus !== 'applied'"
              class="plan-change-chip plan-change-chip--muted"
              >{{ record.planChangeStatus }}</span
            >
          </div>

          <!-- Action Buttons (wash history only) -->
          <div class="card-actions" *ngIf="!record.isPlanChangeRecord">
            <button class="action-btn print-btn" (click)="onPrintInvoice(record)">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 5V2h8v3"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <rect
                  x="2"
                  y="5"
                  width="12"
                  height="7"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M4 9h8M4 12h8"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <span>Print Receipt</span>
            </button>
            <button class="action-btn download-btn" (click)="onDownloadInvoice(record)">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M14 10v2.67A1.33 1.33 0 0 1 12.67 14H3.33A1.33 1.33 0 0 1 2 12.67V10m2.67-2.67L8 10.67l3.33-3.34M8 2v8.67"
                  stroke="#0040E0"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Download Invoice</span>
            </button>
          </div>
        </div>

        <!-- Details Section -->
        <div class="details-section">
          <div class="price-text" *ngIf="!record.isPlanChangeRecord">
            {{ record.price }}
          </div>

          <!-- CWS-1444: a membership plan change. The sentence is built server-side
               so this tab, the Orders entry and any report all say the same thing. -->
          <div class="info-grid" *ngIf="record.isPlanChangeRecord">
            <p class="plan-change-line">{{ record.planChangeLine }}</p>
            <div class="info-row">
              <div class="info-item info-item--labeled" *ngIf="record.planChangeMoney">
                <span class="field-label">Money</span>
                <span class="info-text">{{ record.planChangeMoney }}</span>
              </div>
              <div class="info-item info-item--labeled" *ngIf="record.planChangeRefundOption">
                <span class="field-label">Refund option</span>
                <span class="info-text">{{ record.planChangeRefundOption }}</span>
              </div>
              <div class="info-item info-item--labeled" *ngIf="record.planChangeWashes">
                <span class="field-label">Washes this cycle</span>
                <span class="info-text">{{ record.planChangeWashes }}</span>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item info-item--labeled">
                <span class="field-label">Date</span>
                <span class="info-text">{{ record.date }}</span>
              </div>
              <div class="info-item info-item--labeled" *ngIf="record.location !== '—'">
                <span class="field-label">Location</span>
                <span class="info-text">{{ record.location }}</span>
              </div>
            </div>
          </div>

          <!-- Wash service-history fields -->
          <div class="info-grid" *ngIf="!record.isPlanChangeRecord">
            <div class="info-row">
              <!-- Date Info -->
              <div class="info-item">
                <div class="info-icon">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.333 1.5V4.83333M4.66634 1.5V4.83333M1.33301 8.16667H14.6663M7.16634 11.5H7.99967V14M1.33301 4.83333C1.33301 4.39131 1.5086 3.96738 1.82116 3.65482C2.13372 3.34226 2.55765 3.16667 2.99967 3.16667H12.9997C13.4417 3.16667 13.8656 3.34226 14.1782 3.65482C14.4907 3.96738 14.6663 4.39131 14.6663 4.83333V14.8333C14.6663 15.2754 14.4907 15.6993 14.1782 16.0118C13.8656 16.3244 13.4417 16.5 12.9997 16.5H2.99967C2.55765 16.5 2.13372 16.3244 1.82116 16.0118C1.5086 15.6993 1.33301 15.2754 1.33301 14.8333V4.83333Z"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span class="info-text">{{ record.date }}</span>
              </div>

              <!-- Vehicle Info -->
              <div class="info-item">
                <div class="info-icon">
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.16699 10.6667C3.16699 11.1087 3.34259 11.5326 3.65515 11.8452C3.96771 12.1577 4.39163 12.3333 4.83366 12.3333C5.27569 12.3333 5.69961 12.1577 6.01217 11.8452C6.32473 11.5326 6.50033 11.1087 6.50033 10.6667C6.50033 10.2246 6.32473 9.80072 6.01217 9.48816C5.69961 9.1756 5.27569 9 4.83366 9C4.39163 9 3.96771 9.1756 3.65515 9.48816C3.34259 9.80072 3.16699 10.2246 3.16699 10.6667ZM11.5003 10.6667C11.5003 11.1087 11.6759 11.5326 11.9885 11.8452C12.301 12.1577 12.725 12.3333 13.167 12.3333C13.609 12.3333 14.0329 12.1577 14.3455 11.8452C14.6581 11.5326 14.8337 11.1087 14.8337 10.6667C14.8337 10.2246 14.6581 9.80072 14.3455 9.48816C14.0329 9.1756 13.609 9 13.167 9C12.725 9 12.301 9.1756 11.9885 9.48816C11.6759 9.80072 11.5003 10.2246 11.5003 10.6667Z"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3.16667 10.6667H1.5V5.66667M1.5 5.66667L3.16667 1.5H10.6667L14 5.66667M1.5 5.66667H14M14 5.66667H14.8333C15.2754 5.66667 15.6993 5.84226 16.0118 6.15482C16.3244 6.46738 16.5 6.89131 16.5 7.33333V10.6667H14.8333M11.5 10.6667H6.5M9 5.66667V1.5"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span class="info-text">{{ record.vehicle }}</span>
              </div>
            </div>

            <div class="info-row">
              <!-- Location Info -->
              <div class="info-item">
                <div class="info-icon">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 7.66602C5.5 8.32906 5.76339 8.96494 6.23223 9.43378C6.70107 9.90262 7.33696 10.166 8 10.166C8.66304 10.166 9.29893 9.90262 9.76777 9.43378C10.2366 8.96494 10.5 8.32906 10.5 7.66602C10.5 7.00297 10.2366 6.36709 9.76777 5.89825C9.29893 5.42941 8.66304 5.16602 8 5.16602C7.33696 5.16602 6.70107 5.42941 6.23223 5.89825C5.76339 6.36709 5.5 7.00297 5.5 7.66602Z"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.7138 12.3806L9.17801 15.9164C8.8655 16.2286 8.44183 16.404 8.00009 16.404C7.55836 16.404 7.13469 16.2286 6.82218 15.9164L3.28551 12.3806C2.3532 11.4482 1.71829 10.2603 1.46108 8.96714C1.20388 7.67395 1.33592 6.33352 1.84051 5.11537C2.34511 3.89721 3.19959 2.85604 4.29591 2.12351C5.39223 1.39098 6.68115 1 7.99968 1C9.3182 1 10.6071 1.39098 11.7034 2.12351C12.7998 2.85604 13.6542 3.89721 14.1588 5.11537C14.6634 6.33352 14.7955 7.67395 14.5383 8.96714C14.2811 10.2603 13.6462 11.4482 12.7138 12.3806Z"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span class="info-text">{{ record.location }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <span class="source-label">Source</span>
          <span
            class="source-chip"
            [class.source-chip--grey]="record.sourceChipVariant === 'grey'"
            [class.source-chip--blue]="record.sourceChipVariant === 'blue'"
          >
            {{ record.sourceLabel }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
